import { QUERY_KEYS } from 'api/query-keys';
import { sharedShiftService } from 'api/services';
import { useQuery, UseQueryResult } from 'react-query';
import { useAlert } from 'shared/components/alerts';
import { Site } from 'shared/hooks';
import {
  WorkCreateDataModel,
  workCreateDataResponse2WorkCreateDataModel,
} from './get-work-create-data-mapper';

export function useGetWorkCreateData(
  site: Site,
  companyId?: string,
  enabled: boolean = true
): UseQueryResult<WorkCreateDataModel> {
  const { alertError } = useAlert();

  return useQuery(
    QUERY_KEYS.workCreateData(companyId),
    async () => await sharedShiftService.getShiftCreateData(site, companyId),
    { enabled, onError: (e) => alertError(e), select: workCreateDataResponse2WorkCreateDataModel }
  );
}
